import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, apiMutate } from "@/lib/api";

interface Memory {
  id: string;
  content: string;
  source: "auto" | "manual";
  created_at: string;
}

export function useMemories() {
  return useQuery({
    queryKey: ["memories"],
    queryFn: () => apiFetch<Memory[]>("/api/memories"),
    staleTime: 5 * 60 * 1000,
  });
}

export function useCreateMemory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (content: string) =>
      apiMutate<Memory>("/api/memories", "POST", { content }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["memories"] }),
  });
}

export function useDeleteMemory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiMutate<void>(`/api/memories/${id}`, "DELETE"),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["memories"] }),
  });
}
